import styled from 'styled-components';

export const StyledGlobalContent = styled.div``;
